webpackJsonp([25],{

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__(79);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__(3);
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__(31);
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./src/utils/default.js
var utils_default = __webpack_require__(35);

// EXTERNAL MODULE: ./src/mixins/pagination.js
var pagination = __webpack_require__(115);

// EXTERNAL MODULE: ./src/components/formatters/index.js + 12 modules
var formatters = __webpack_require__(48);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Table.vue







/* harmony default export */ var Table = ({
  components: {
    Date: formatters["a" /* Date */],
    Price: formatters["d" /* Price */],
    Minute: formatters["c" /* Minute */]
  },
  mixins: [Object(pagination["a" /* default */])('skiliko/users')],
  props: {
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    descending: {
      type: Boolean,
      default: true
    },
    sortBy: {
      type: String,
      default: null
    },
    dataFilter: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      selectedItems: this.selected,
      filter: extends_default()({
        page: this.page,
        descending: this.descending,
        sortBy: this.sortBy
      }, this.dataFilter)
    };
  },

  computed: {
    headers: function headers() {
      return [{ text: this.$t('user.table.header.nickname'), left: true, sortable: true, value: 'nickname' }, { text: this.$t('user.table.header.last_name'), left: true, sortable: true, value: 'last_name' }, { text: this.$t('user.table.header.first_name'), left: true, sortable: true, value: 'first_name' }, { text: this.$t('user.table.header.email'), left: true, sortable: true, value: 'email' }, { text: this.$t('user.table.header.payed_purchases_sum'), left: false, sortable: true, value: 'payed_purchases_sum' }, { text: this.$t('user.table.header.phone_seconds_available'), left: false, sortable: true, value: 'phone_seconds_available' }, { text: this.$t('user.table.header.created_at'), left: false, sortable: true, value: 'created_at' }, { text: this.$t('user.table.header.current_sign_in_at'), left: false, sortable: true, value: 'current_sign_in_at' }];
    }
  },
  watch: {
    dataFilter: function dataFilter() {
      var _this = this;

      var filterWithoutSearch = keys_default()(this.filter).filter(function (x) {
        return !x.startsWith('q[');
      }).reduce(function (acc, x) {
        return extends_default()({}, acc, defineProperty_default()({}, x, _this.filter[x]));
      }, {});
      this.filter = extends_default()({}, filterWithoutSearch, this.dataFilter);
    },
    selectedItems: function selectedItems() {
      this.$emit('input', this.selectedItems);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51dafb1d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Table.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.users,"loading":_vm.loading,"pagination":_vm.filter,"total-items":_vm.pagination.total,"rows-per-page-items":[_vm.pagination.perPage],"select-all":"","selected-key":"id","no-data-text":_vm.$t('user.table.noDataText'),"no-results-text":_vm.$t('user.table.noResultsText'),"rows-per-page-text":_vm.$t('user.table.rowsPerPageText'),"hide-actions":""},on:{"update:pagination":function($event){_vm.filter=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{ name: 'User', params: { id: props.item.id, tab: 'profile' } }}},[_vm._v(_vm._s(props.item.nickname))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.last_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.first_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.email))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('price',{attrs:{"value":props.item.stats.purchases.total}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('minute',{attrs:{"value":props.item.phone_seconds_available}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('date',{attrs:{"value":props.item.created_at}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('date',{attrs:{"value":props.item.current_sign_in_at}})],1)]}}]),model:{value:(_vm.selectedItems),callback:function ($$v) {_vm.selectedItems=$$v},expression:"selectedItems"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-3 pb-3"},[(_vm.filter)?_c('v-pagination',{attrs:{"disabled":_vm.loading,"value":_vm.filter.page,"length":Math.ceil(_vm.pagination.total / _vm.pagination.perPage)},on:{"input":function (value) { return _vm.changePage(value); }}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var user_Table = (esExports);
// CONCATENATED MODULE: ./src/components/user/Table.vue
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Table,
  user_Table,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_user_Table = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__(92);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(93);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/api/user.js
var user = __webpack_require__(364);

// EXTERNAL MODULE: ./src/components/messenger/MessageForm.vue + 19 modules
var MessageForm = __webpack_require__(367);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__(7);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Form.vue




/* harmony default export */ var Form = ({
  data: function data() {
    return {
      error: {},
      sendEmail: true,
      email: null,
      password: null,
      passwordConfirmation: null
    };
  },

  computed: Object(vuex_esm["c" /* mapGetters */])({
    loading: 'skiliko/users/isLoading'
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])({
    create: 'skiliko/users/create'
  }), {
    clear: function clear() {
      this.email = this.password = this.passwordConfirmation = null;
    },
    submit: function submit() {
      var _this = this;

      this.error = {};
      return this.create({
        email: this.email,
        password: this.password,
        password_confirmation: this.passwordConfirmation,
        email_notification: this.sendEmail
      }).then(function (user) {
        _this.clear();
        _this.$emit('created', user);
      }).catch(function (_ref) {
        var response = _ref.response;
        return _this.error = (response || {}).data || {};
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dd70976","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Form.vue
var Form_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":_vm.$t('user.form.labels.email'),"error":(_vm.error.email || []).length > 0,"rules":_vm.error.email,"type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('user.form.labels.password'),"error":(_vm.error.password || []).length > 0,"rules":_vm.error.password,"type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm.$t('user.form.labels.passwordConfirmation'),"error":(_vm.error.password_confirmation || []).length > 0,"rules":_vm.error.password_confirmation,"type":"password"},model:{value:(_vm.passwordConfirmation),callback:function ($$v) {_vm.passwordConfirmation=$$v},expression:"passwordConfirmation"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":_vm.$t('user.form.labels.sendEmail')},model:{value:(_vm.sendEmail),callback:function ($$v) {_vm.sendEmail=$$v},expression:"sendEmail"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"primary":"","light":"","ripple":"","loading":_vm.loading},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_vm._v("\n      "+_vm._s(_vm.$t('user.form.save'))+"\n    ")])],1)],1)}
var Form_staticRenderFns = []
var Form_esExports = { render: Form_render, staticRenderFns: Form_staticRenderFns }
/* harmony default export */ var user_Form = (Form_esExports);
// CONCATENATED MODULE: ./src/components/user/Form.vue
var Form_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Form___vue_template_functional__ = false
/* styles */
var Form___vue_styles__ = null
/* scopeId */
var Form___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Form___vue_module_identifier__ = null
var Form_Component = Form_normalizeComponent(
  Form,
  user_Form,
  Form___vue_template_functional__,
  Form___vue_styles__,
  Form___vue_scopeId__,
  Form___vue_module_identifier__
)

/* harmony default export */ var components_user_Form = (Form_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/ImportForm.vue





/* harmony default export */ var ImportForm = ({
  data: function data() {
    return {
      file: null,
      sendEmail: true
    };
  },

  methods: {
    fileUpdate: function fileUpdate(e) {
      this.file = e.currentTarget.files[0];
    },
    submit: function submit() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return user["a" /* default */].importUsers({
                  file: _this.file,
                  email_notification: _this.sendEmail
                });

              case 2:
                _this.$emit('imported');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27581023","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ImportForm.vue
var ImportForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.fileUpdate}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":_vm.$t('user.import.labels.sendEmail')},model:{value:(_vm.sendEmail),callback:function ($$v) {_vm.sendEmail=$$v},expression:"sendEmail"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{staticClass:"ml-2",attrs:{"primary":"","light":"","ripple":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit()}}},[_vm._v("\n      "+_vm._s(_vm.$t("user.import.save"))+"\n    ")])],1)],1)}
var ImportForm_staticRenderFns = []
var ImportForm_esExports = { render: ImportForm_render, staticRenderFns: ImportForm_staticRenderFns }
/* harmony default export */ var user_ImportForm = (ImportForm_esExports);
// CONCATENATED MODULE: ./src/components/user/ImportForm.vue
var ImportForm_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var ImportForm___vue_template_functional__ = false
/* styles */
var ImportForm___vue_styles__ = null
/* scopeId */
var ImportForm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ImportForm___vue_module_identifier__ = null
var ImportForm_Component = ImportForm_normalizeComponent(
  ImportForm,
  user_ImportForm,
  ImportForm___vue_template_functional__,
  ImportForm___vue_styles__,
  ImportForm___vue_scopeId__,
  ImportForm___vue_module_identifier__
)

/* harmony default export */ var components_user_ImportForm = (ImportForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UsersMenu.vue








/* harmony default export */ var UsersMenu = ({
  components: {
    MessageForm: MessageForm["a" /* default */],
    UserForm: components_user_Form,
    ImportForm: components_user_ImportForm
  },
  props: {
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      chatPopup: false,
      chatAllPopup: false,
      userFormPopup: false,
      userImportPopup: false
    };
  },

  computed: {
    chatUsers: function chatUsers() {
      return this.selected.map(function (e) {
        return {
          _id: e.chatable_id,
          name: e.nickname
        };
      });
    }
  },
  methods: {
    exportUsers: function exportUsers() {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return user["a" /* default */].exportUsers();

              case 2:
                alert(_this.$t('usermenu.exportStarted'));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    onUserAdded: function onUserAdded(user) {
      this.userFormPopup = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f6a0320e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UsersMenu.vue
var UsersMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","outline":"","primary":""},slot:"activator"},[_vm._v("\n      "+_vm._s(_vm.$t('usermenu.actions'))+"\n      "),_c('v-icon',{staticClass:"primary--text ml-2"},[_vm._v("keyboard_arrow_down")])],1),_vm._v(" "),_c('v-list',[(_vm.selected.length)?_c('v-list-item',[_c('v-list-tile',{nativeOn:{"click":function($event){_vm.chatPopup = true}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('usermenu.send')))])],1)],1):_c('v-list-item',[_c('v-list-tile',{nativeOn:{"click":function($event){_vm.chatAllPopup = true}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('usermenu.sendToAll')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-tile',{nativeOn:{"click":function($event){_vm.userFormPopup = true}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('usermenu.addUser')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-tile',{nativeOn:{"click":function($event){return _vm.exportUsers.apply(null, arguments)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('usermenu.export')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-tile',{nativeOn:{"click":function($event){_vm.userImportPopup = true}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('usermenu.import')))])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.chatPopup),callback:function ($$v) {_vm.chatPopup=$$v},expression:"chatPopup"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('usermenu.send')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('message-form',{attrs:{"user":_vm.chatUsers,"redirect":false}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.chatAllPopup),callback:function ($$v) {_vm.chatAllPopup=$$v},expression:"chatAllPopup"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('usermenu.sendToAll')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('message-form',{attrs:{"user":'all',"redirect":false}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.userFormPopup),callback:function ($$v) {_vm.userFormPopup=$$v},expression:"userFormPopup"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('usermenu.addUser')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('user-form',{on:{"created":_vm.onUserAdded}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.userImportPopup),callback:function ($$v) {_vm.userImportPopup=$$v},expression:"userImportPopup"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('usermenu.import')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('import-form',{on:{"imported":function($event){_vm.userImportPopup = false}}})],1)],1)],1)}
var UsersMenu_staticRenderFns = []
var UsersMenu_esExports = { render: UsersMenu_render, staticRenderFns: UsersMenu_staticRenderFns }
/* harmony default export */ var components_UsersMenu = (UsersMenu_esExports);
// CONCATENATED MODULE: ./src/components/UsersMenu.vue
var UsersMenu_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var UsersMenu___vue_template_functional__ = false
/* styles */
var UsersMenu___vue_styles__ = null
/* scopeId */
var UsersMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UsersMenu___vue_module_identifier__ = null
var UsersMenu_Component = UsersMenu_normalizeComponent(
  UsersMenu,
  components_UsersMenu,
  UsersMenu___vue_template_functional__,
  UsersMenu___vue_styles__,
  UsersMenu___vue_scopeId__,
  UsersMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_UsersMenu = (UsersMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/user/Search.vue



/* harmony default export */ var Search = ({
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      search: {
        first_name_cont: this.value.first_name_cont,
        last_name_cont: this.value.last_name_cont,
        email_cont: this.value.email_cont,
        phone_cont: this.value.phone_cont,
        nickname_cont: this.value.nickname_cont
      },
      locked: this.value.locked_at_not_null,
      risky_at: this.value.risky_at_not_null
    };
  },

  computed: {
    fields: function fields() {
      var _this = this;

      return ['first_name_cont', 'last_name_cont', 'nickname_cont', 'email_cont', 'phone_cont'].map(function (key) {
        return {
          key: key,
          label: _this.$t('user.search.labels.' + key)
        };
      });
    }
  },
  methods: {
    clear: function clear() {
      this.$emit('input', {});
    },
    submit: function submit() {
      this.$emit('input', extends_default()({}, this.search, this.locked ? { locked_at_not_null: true } : {}, this.risky_at ? { risky_at_not_null: true } : {}));
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35a991da","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Search.vue
var Search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.fields),function(field){return _c('v-flex',{key:field.key,attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":field.label},model:{value:(_vm.search[field.key]),callback:function ($$v) {_vm.$set(_vm.search, field.key, $$v)},expression:"search[field.key]"}})],1)}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-switch',{attrs:{"label":_vm.$t('user.search.labels.locked')},model:{value:(_vm.locked),callback:function ($$v) {_vm.locked=$$v},expression:"locked"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-switch',{attrs:{"label":_vm.$t('user.search.labels.risky_at')},model:{value:(_vm.risky_at),callback:function ($$v) {_vm.risky_at=$$v},expression:"risky_at"}})],1)],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-row',{attrs:{"actions":""}},[_c('v-btn',{staticClass:"mr-2",attrs:{"light":"","secondary":""},nativeOn:{"click":function($event){return _vm.clear.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('user.search.clear')))]),_vm._v(" "),_c('v-btn',{attrs:{"light":"","type":"submit","primary":""}},[_vm._v(_vm._s(_vm.$t('user.search.submit')))])],1)],1)])}
var Search_staticRenderFns = []
var Search_esExports = { render: Search_render, staticRenderFns: Search_staticRenderFns }
/* harmony default export */ var user_Search = (Search_esExports);
// CONCATENATED MODULE: ./src/components/user/Search.vue
var Search_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Search___vue_template_functional__ = false
/* styles */
var Search___vue_styles__ = null
/* scopeId */
var Search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Search___vue_module_identifier__ = null
var Search_Component = Search_normalizeComponent(
  Search,
  user_Search,
  Search___vue_template_functional__,
  Search___vue_styles__,
  Search___vue_scopeId__,
  Search___vue_module_identifier__
)

/* harmony default export */ var components_user_Search = (Search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Users.vue









/* harmony default export */ var Users = ({
  components: {
    UserTable: components_user_Table,
    UsersMenu: src_components_UsersMenu,
    UserSearchForm: components_user_Search
  },
  props: {
    page: {
      type: Number,
      default: 1
    },
    descending: {
      type: Boolean,
      default: true
    },
    sortBy: {
      type: String,
      default: null
    }
  },
  data: function data() {
    var _this = this;

    return {
      selected: [],
      search: false,
      rawDataFilter: keys_default()(this.$route.query).filter(function (x) {
        return x.startsWith('q[');
      }).map(function (x) {
        return x.replace('q[', '').replace(']', '');
      }).reduce(function (acc, res) {
        return extends_default()({}, acc, defineProperty_default()({}, res, _this.$route.query['q[' + res + ']']));
      }, {})
    };
  },

  computed: {
    dataFilter: function dataFilter() {
      var _this2 = this;

      return keys_default()(this.rawDataFilter).reduce(function (acc, x) {
        return extends_default()({}, acc, defineProperty_default()({}, 'q[' + x + ']', _this2.rawDataFilter[x]));
      }, {});
    }
  },
  methods: {
    onFilterUpdated: function onFilterUpdated(filter) {
      this.$router.push(extends_default()({}, this.$route, {
        query: utils_default["a" /* default */].dataForUrl(filter)
      }));
    }
  },
  watch: {
    rawDataFilter: function rawDataFilter() {
      this.search = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5c4f26","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Users.vue
var Users_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[(!_vm.selected.length)?_c('span',{staticClass:"hidden-xs-only"},[_vm._v(_vm._s(_vm.$t('pages.users.title')))]):_c('span',{staticClass:"hidden-xs-only"},[_vm._v(_vm._s(_vm.selected.length)+" "+_vm._s(_vm.$tc('pages.users.selected', _vm.selected.length)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.search = !_vm.search}}},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("search")])],1),_vm._v(" "),_c('users-menu',{staticClass:"ml-2",attrs:{"selected":_vm.selected}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"640px"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('pages.users.search')))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('user-search-form',{model:{value:(_vm.rawDataFilter),callback:function ($$v) {_vm.rawDataFilter=$$v},expression:"rawDataFilter"}})],1)],1),_vm._v(" "),_c('user-table',{attrs:{"page":_vm.page,"descending":_vm.descending,"sortBy":_vm.sortBy,"dataFilter":_vm.dataFilter},on:{"filterUpdated":function (data) { return _vm.onFilterUpdated(data); }},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var Users_staticRenderFns = []
var Users_esExports = { render: Users_render, staticRenderFns: Users_staticRenderFns }
/* harmony default export */ var pages_Users = (Users_esExports);
// CONCATENATED MODULE: ./src/pages/Users.vue
var Users_normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var Users___vue_template_functional__ = false
/* styles */
var Users___vue_styles__ = null
/* scopeId */
var Users___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Users___vue_module_identifier__ = null
var Users_Component = Users_normalizeComponent(
  Users,
  pages_Users,
  Users___vue_template_functional__,
  Users___vue_styles__,
  Users___vue_scopeId__,
  Users___vue_module_identifier__
)

/* harmony default export */ var src_pages_Users = __webpack_exports__["default"] = (Users_Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/25.4bff07a9b892fd1fd90c.js